export const text =
  '【TiDB Infra Meetup - 用户实践场】9 月 21 号下午 14:00，让我们相约 PingCAP 视频号，聊聊 TiDB 新版本使用体验，分享升级实战经验！';
export const link = 'https://asktug.com/t/topic/1032014';
